module.exports = __webpack_public_path__ + "static/media/08.8384680a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/08.jpg
// module id = 698
// module chunks = 0